import { FC, PropsWithChildren } from "react"
import style from "./AbsolutCentered.module.css"

export const AbsolutCentered: FC<PropsWithChildren> = ({ children }) => {
	return <div className={style.wrapper}>{children}</div>
}
